import { Modal } from "antd";
import { releaseAntModalLock } from "../../../helpers/releaseAntModalLock";

const MOBILE_BREAKPOINT = 768;

export function opConfirmModal(options = {}) {
  const isMobile =
    typeof window !== "undefined" && window.innerWidth <= MOBILE_BREAKPOINT;

  const { afterClose, ...rest } = options;

  return Modal.confirm({
    centered: true,
    width: 416,
    ...(isMobile ? { wrapClassName: "op-compact-modal-wrap" } : {}),
    ...rest,
    afterClose: () => {
      releaseAntModalLock();
      afterClose?.();
    },
  });
}
